import { CSSProperties } from "react";

export default class BillingInfoViewStyle {

    form : CSSProperties = {
        display : 'flex',
        flexDirection : 'column',
        flex : 1,
        justifyContent : 'space-between',
        marginTop:20 
    }

    inputRow : CSSProperties = {
        display : 'flex'
    }

    inputMargin : CSSProperties = {
        marginRight : 15
    }
}